import { injectable, inject } from 'inversify';
import * as Common from '../common';
import * as Api from '../api';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { XApiClient } from '@/app/tracking/xapi/tincan/client';
import { SectionExperiencedStatementParams,
         createSectionExperiencedStatement } from './section-experienced-statement';

@injectable()
export class XApiCompleteSectionCommandHandler implements CommandHandler<Api.CompleteSectionCommand> {

  constructor(
    @inject(XApiClient)
    private client: XApiClient) {
  }

  public async execute(command: Api.CompleteSectionCommandPayload) {

    // TODO: factory
    const params: SectionExperiencedStatementParams = {
      id: command.sectionId,
      title: command.meta.title
    };

    const statement = createSectionExperiencedStatement(params);
    await this.client.sendStatement(statement);
  }
}
